module.exports = __webpack_public_path__ + "img/248.2fc65cf3.jpg";